import http from './http';

// New document-focused structure for advance directive
export interface AdvanceDirectiveData {
  id?: string;
  documentId?: string; // ID from document repository if uploaded
  hasDigitalCopy?: boolean;
  physicalLocation?: string; // Where physical document is stored
  attorneyContact?: string; // Legal advisor contact info
  familyInformed?: boolean;
  lastUpdated?: string;
  specificInstructions?: string;
}

class AdvanceDirectiveService {
  async createAdvanceDirective(data: Omit<AdvanceDirectiveData, 'id'>): Promise<AdvanceDirectiveData> {
    const response = await http.post('/api/advance-directive', data);
    return response.data.data || response.data;
  }

  async updateAdvanceDirective(id: string, data: Partial<AdvanceDirectiveData>): Promise<AdvanceDirectiveData> {
    const response = await http.patch(`/api/advance-directive/${id}`, data);
    return response.data.data || response.data;
  }

  async getAdvanceDirectiveById(id: string): Promise<AdvanceDirectiveData> {
    const response = await http.get(`/api/advance-directive/${id}`);
    return response.data.data || response.data;
  }

  async getAllAdvanceDirectives(): Promise<AdvanceDirectiveData[]> {
    const response = await http.get('/api/advance-directive');
    return response.data.data || response.data;
  }

  async deleteAdvanceDirective(id: string): Promise<void> {
    await http.delete(`/api/advance-directive/${id}`);
  }

  async lockAdvanceDirective(id: string): Promise<void> {
    await http.post(`/api/advance-directive/${id}/lock`);
  }

  async unlockAdvanceDirective(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/advance-directive/${id}/unlock`, { emails });
  }

  async getAdvanceDirectiveAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/advance-directive/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const advanceDirectiveService = new AdvanceDirectiveService();